import React from 'react';
import { Alert, View } from 'react-native';
import OtpWrapperweb from '@fkhplus/common/src/components/molecules/OTPVerification/OtpWrapperweb';

const WebOTP = () => {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      }}>
     <OtpWrapperweb 
     onSubmitOTP={()=>Alert.alert("onSubmitOTP")}
     />
    </View>
  )
}
export default WebOTP;